export default __webpack_public_path__ + "static/media/IMG_4899.5d7c9e08.png";